import { classNames } from '@/util/tailwindHelpers'
import styles from './footer.module.scss'

const ModalFooter = ({ children, className }) => {
  return (
    <footer
      className={classNames(
        styles.footer,
        className,
        '-mx-[var(--modalPadding)]'
      )}
    >
      {children}
    </footer>
  )
}

export default ModalFooter
